<template>
  <v-card outlined>
    <v-tabs
      v-model="activeTab"
      grow
      color="primary"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.key"
      >
        {{ tab.label }}
        <v-chip
          v-if="tab.count !== null"
          x-small
          class="ml-2"
          :color="tab.key === 'matched' ? 'primary' : 'amber darken-2'"
          text-color="white"
        >
          {{ tab.count }}
        </v-chip>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.key"
      >
        <bulk-result-tab-body
          :uuid="uuid"
          :tab-key="tab.key"
          :read-only="readOnly"
          :refetch-key="refetchKey"
          @link-bill="$emit('link-bill', $event)"
          @count-changed="onCountChanged(tab.key, $event)"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import BulkResultTabBody from './BulkResultTabBody.vue';

export default {
  name: 'BulkResultTabs',
  components: { BulkResultTabBody },
  props: {
    uuid: { type: String, required: true },
    readOnly: { type: Boolean, default: false },
    refetchKey: { type: Number, default: 0 },
  },
  data() {
    return {
      activeTab: 0,
      counts: { bcel: null, ldb: null, matched: null },
    };
  },
  computed: {
    tabs() {
      return [
        { key: 'bcel', label: 'BCEL unmatched', count: this.counts.bcel },
        { key: 'ldb', label: 'LDB unmatched', count: this.counts.ldb },
        { key: 'matched', label: 'Matched', count: this.counts.matched },
      ];
    },
  },
  methods: {
    onCountChanged(key, count) {
      this.counts = { ...this.counts, [key]: count };
    },
  },
};
</script>
